import Api from '@/services/Api'

export default {
  authorize (creds) {
    return Api().post('stripe/connect/response', creds)
  },
  fetchStripeUserId () {
    return Api().get('stripe/connect/fetchsui')
  }
}



// WEBPACK FOOTER //
// ./src/services/StripeConnectService.js